import React from "react";
import "./../css/Banner.css";
import { API } from "./../utils/helper";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useLoadingOverlay } from "./LoadingOverlayProvider";
import { ToastColor, ToastPlacement } from "./../utils/types";

export default function Banner({
  title,
  withIcons = true,
  align = "left"
}: {
  title: string;
  withIcons?: boolean;
  align?: "left" | "right" | "center";
}) {
  const { loadingIncrement, loadingDecrement, showToast } = useLoadingOverlay();
  const username = window.sessionStorage.getItem("username");
  const companyProfileId = window.sessionStorage.getItem("companyProfileId");
  const individualProfileId = window.sessionStorage.getItem(
    "individualProfileId"
  );
  const navigate = useNavigate();
  let isAuthenticated = !!window.sessionStorage.getItem("token");
  const excludedRoutes = [
    "/",
    "/registration/individual",
    "/registration/corporate",
    "/registration/traders-channel-partner",
    "/auth/code",
    "/auth/forgot",
    "/auth/forgot/reset",
    "/auth/forgot/new",
  ];
  const isOnExludedRoutes = excludedRoutes.includes(window.location.pathname);
  const showUserIcons = React.useMemo(() => {
    return isAuthenticated && !isOnExludedRoutes && withIcons;
  }, [isAuthenticated, isOnExludedRoutes, withIcons]);
  const profile = React.useMemo(() => {
    if (Number(individualProfileId)) {
      return "/individual";
    } else if (Number(companyProfileId)) {
      return "/corporate";
    } else {
      return "/individual";
    }
  }, [individualProfileId, companyProfileId]);

  const logout = () => {
    loadingIncrement();
    const refId = sessionStorage.getItem("refId");
    if (!refId) {
      sessionStorage.clear();
      loadingDecrement();
    }

    axios
      .get(API + `/logout/deletelogin/${refId}`)
      .then((response) => {
        // if (response.data === 1) {
        sessionStorage.clear();
        navigate("/");
        // }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          navigate(
            `/?redirectUrl=${window.location.pathname + window.location.search}`
          );
        }
        showToast({
          color: ToastColor.Danger,
          closeButton: true,
          title:
            error?.response?.data?.message ||
            error?.response?.data ||
            "Failed to logout.",
          placement: ToastPlacement.TopRight,
          timeout: 3000,
          timed: true,
        });
      })
      .finally(() => {
        loadingDecrement();
      });
  };

  const justify =
    align === "left"
      ? "justify-content-start"
      : align === "right"
        ? "justify-content-end"
        : align === "center"
          ? "justify-content-center"
          : "justify-content-between";

  return (
    <>
      <header className="banner position-relative mx-0 w-100 mt-0 mb-2">
        <div className="d-flex">
          <div className={`flex-grow-1 d-flex ${justify}`}>
            <h1 className="fw-normal fs-5 text-white text-center">
              {title}
            </h1>
          </div>
          {showUserIcons && (
            <div className="d-flex gap-3" style={{ width: 'fit-content' }}>
              <a href={`/profile${profile}`} className="text-white fw-normal">
                {username}{" "}
                <i className="bi bi-person" style={{ color: "white" }}></i>
              </a>
              <button className="bg-transparent rounded" onClick={logout}>
                <i
                  className="bi bi-box-arrow-right"
                  style={{ color: "white" }}
                ></i>
              </button>
            </div>
          )}
        </div>
      </header>
    </>
  );
}
